<template>
  <div class="green__products">
<!--    <div class="green__row green__ac">-->
<!--      <div-->
<!--          @click="seePurchase = true"-->
<!--          class="pa-3 green__btn green__mr__xs green__pointer green__see green__row green__ac green__mb__s"-->

<!--          v-bind:class="{'green__active' : seePurchase}"-->
<!--      >-->
<!--        <i class="mdi mdi-plus mr-2"></i>-->
<!--        <p >Добавить товар</p>-->
<!--      </div>-->
<!--      <div-->
<!--          @click="showListCategories()"-->
<!--          class="pa-3 green__btn green__pointer green__see green__row green__ac green__mb__s"-->
<!--          v-bind:class="{'green__active' : !seePurchase}"-->
<!--      >-->
<!--        <i class="mdi mdi-format-align-justify mr-2"></i>-->
<!--        <p >Список товаров</p>-->
<!--      </div>-->
<!--    </div>-->

    <form class="green__mb__s" @submit.prevent="createProduct()">
      <h3 class="mb-2">Создать товар</h3>

      <div
          v-for="(item,index) in configs"
          class="green__size--config"
          :key="index"
      >
        <div class="green__column green__input">
          <p>Выберите размер</p>
          <v-select
              v-model="item.size"
              :items="sizes"
              label="Выберите размер"
              outlined
          ></v-select>
        </div>

        <div class="green__column green__input">
          <p>Выберите рост</p>

          <v-select
              v-model="item.height"
              :items="heights"
              label="Выберите рост"
              outlined
          ></v-select>
        </div>

        <div class="green__column green__input">
          <p>PDF лекало</p>
          <v-file-input
              chips
              counter
              multiple
              small-chips
              v-model="item.file"
              outlined
          ></v-file-input>
        </div>


        <a @click="deleteConfig(index)">Удалить</a>

      </div>

      <button
          @click="addConfig"
          class="green__choose mb-4 green__pointer"
      >
        <i class="mdi mdi-plus"></i>
        Добавить лекало
      </button>


      <div class="green__column green__input">
        <p>Выберите категорию</p>
        <v-select
            v-model="category_id"
            :items="all_categories"
            item-text="name"
            item-value="id"
            label="Выберите категорию"
            outlined
        ></v-select>
      </div>
      <div class="green__column green__input">
        <p>Название</p>
        <v-text-field
            v-model="title"
            label="Название"
            required
            outlined
        ></v-text-field>
      </div>

      <div class="green__row green__ac">
        <div class="green__column green__mr__xs green__input">
          <p>Цена</p>
          <v-text-field
              v-model="price"
              label="Цена"
              required
              outlined
          ></v-text-field>
        </div>

        <div class="green__column green__input">
          <p class="green__mb__xs">Измерение</p>
          <v-select
              v-model="count_type"
              :items="count_types"
              item-text="name"
              item-value="id"
              label="Выберите измерение"
              outlined
              required
          ></v-select>
        </div>

      </div>

      <div class="green__column green__input green__mb__s">
        <p>Загрузить фото</p>
        <input type="file" multiple @change="uploadDoc"/>
      </div>


      <div class="green__column green__input green__quill">
        <p>Описание</p>
<!--        <v-textarea v-model="description" label="Описание" outlined></v-textarea>-->
        <quill-editor v-model="description" :options="editorConfig"></quill-editor>
      </div>


      <button type="submit">
        <p>Сохранить</p>
      </button>
    </form>

  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css'; // Import Quill's CSS

export default {
  components: {
    quillEditor,
  },
  data() {
    return {

      editorConfig: {
        placeholder: 'Описание..',
        theme: 'snow', // Default theme
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }], // Header dropdown
            ['bold', 'italic', 'underline', 'strike'], // Formatting buttons
            ['blockquote', 'code-block'], // Blockquote and code block
            [{ list: 'ordered' }, { list: 'bullet' }], // Lists
            [{ script: 'sub' }, { script: 'super' }], // Subscript/Superscript
            [{ indent: '-1' }, { indent: '+1' }], // Indent buttons
            [{ direction: 'rtl' }], // Text direction
            [{ size: ['small', false, 'large', 'huge'] }], // Font size
            [{ color: [] }, { background: [] }], // Text and background color
            [{ align: [] }], // Text alignment
          ],
        },
        containerClass: 'custom-editor', // Add your custom class
      },
      file: '',
      id: '',
      open_edit_modal: false,

      configs: [
        {
          size: '',
          height: '',
          file: ''
        }
      ],
      height: [],
      heights: [
        'Стандарт', '154-160', '162-168', '170-176', '178-182', '184-190'
      ],
      size: [],
      sizes: ['Стандарт','42', '44', '46', '48', '50', '52', '54'],
      count: '',
      showSkeleton: false,
      showCategorySkeleton: true,
      seePurchase: true,
      title: "",
      description: "",
      priority: 0,
      category_name: "",
      categories: [],
      all_categories: [],
      category_id: '',
      price: '',
      price_sale: 0,
      name: '',
      createLoader: false,
      current_category_index: 0,
      nested: '',
      products: [],
      page_category: '',
      user: {
        id: ''
      },
      count_type: "",
      count_types: [
        {
          id: 1,
          name: "Шт",
        }
      ],
      documents: [],
      selected_category: ''
    }
  },
  methods: {
    deleteConfig(index) {
      this.configs.splice(index,1)
    },
    uploadDoc(e) {
      const file = e.target.files;
      for (let i = 0; i < file.length; i++) {
        this.documents.push(file[i]);
      }
    },
    addConfig() {
      this.configs.push({ size: '',height: '',file:'' })
    },
    editPurchase(index) {
      this.products[index].edit = !this.products[index].edit;
      let p = this.products;
      this.products = [];
      this.products = p;
    },
    getProductByCategorySecond(id, type) {
      this.showSkeleton = true;
      let t = "";
      if (!type) {
        type = this.category_type;
      }
      if (type == "child") {
        t = this.nested.filter((item) => item.id == id);
      } else {
        t = this.categories.filter((item) => item.id == id);
      }
      this.selected_category = t[0]["name"];
      this.dialogApplication = false;
      let data = {
        category_id: id,
      };
      this.$http
          .post("/get/products/admin/by/category", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.message_notif = res.data.message;
            this.products = res.data;
            this.showSkeleton = false;
          });
    },
    convert_date(date) {
      if (date) {
        let day = date.split("T")[0].split("-")[2];
        let month = date.split("T")[0].split("-")[1];
        let year = date.split("T")[0].split("-")[0];

        let hour = date.split("T")[1].split(":")[0];
        let minute = date.split("T")[1].split(":")[1];
        let ready = day + "." + month + "." + year;

        return ready + " " + hour + ":" + minute;
      }
    },
    showListCategories() {
      this.seePurchase = false;
      this.getCategories();
    },
    getCategories() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/categories", config).then((res) => {
        this.categories = res.data;
        this.showCategorySkeleton = false

      });
    },
    getAllCategories() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/all/categories", config).then((res) => {
        this.all_categories = res.data;
      });
    },
    createProduct() {
      this.createLoader = true;
      if (!this.category_id) {
        alert("Выберите категорию");
      }
      let fd = new FormData();
      fd.append("name", this.title);
      fd.append("category_id", this.category_id);
      fd.append("price", this.price);
      fd.append("count", this.count);
      fd.append("count_type", this.count_type);
      fd.append("sizes", JSON.stringify(this.size));
      fd.append("heights", JSON.stringify(this.height));

      this.configs.forEach((item, index) => {
        fd.append(`configs[${index}][size]`, item.size);
        fd.append(`configs[${index}][height]`, item.height);
        if (item.file && item.file.length) {
          for (let i = 0; i < item.file.length; i++) {
            fd.append(`configs[${index}][files][]`, item.file[i]);
          }
        } else {
          console.warn(`No files found for config ${index}`);
        }
      });

      for (let i = 0; i < this.documents.length; i++) {
        fd.append("images[]", this.documents[i]);
      }


      fd.append("description", this.description);
      this.$http
          .post("/create/product", fd, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.createLoader = false;
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });

            this.documents = [];

            this.message_notif = res.data.message;
            this.getCategories();
            this.getProductByCategory(this.category_id, parent);

            this.seePurchase = true;

            this.name = ''
            this.description = ''
            this.height = ''
            this.size = ''
            this.count = ''
            this.price = ''
            this.price_sale = ''
            this.count_type = ''
            this.category_id = ''
            this.count = ''


          }).catch((error) => {
            let errors = error.response.data.error;
            for (let variable in errors) {
              this.$toast.open({
                message: errors[variable][0],
                type: "error",
                position: "bottom",
                duration: 5000,
                queue: true,
              });
              continue;
            }
            this.documents = [];
          });
    },
  },
  mounted() {
    this.getCategories()
    this.getAllCategories()
  }
}
</script>

<style scoped lang="less">
.custom-editor {
  width: 100%; /* Full width */
  height: 400px; /* Set height */
  margin-bottom: 40px;
}
.admin__loader {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 10;
  bottom: 0;
  background-image: linear-gradient(to right,
  #253532,
  #1e363d,
  #273345,
  #3c2e43,
  #4c2934);

  i {
    font-size: 36px;
    color: white;
  }

  p {
    font-size: 36px;
    color: white;
  }
}

@mobile: 900px;
@planshet: 1200px;
.mdi-logout {
  font-size: 26px;
  position: absolute;
  right: 20px;
  color: white;
  top: 20px;
}

.bonus__actions {
  width: 100%;
  z-index: 10;
  position: fixed;
  background: #191a21;
  bottom: 0;
  padding: 20px;

  .bonus__actions__btn {
    i {
      color: white;
      font-size: 32px;
    }
  }

  // p {
  //     padding: 15px;
  //     background-image: linear-gradient(to right, #131215, #1d161e, #2b1824, #3a1924, #481b20);
  //     border-radius: 20px;
  //     color: white;
  //     text-align: center;
  //     font-weight: bold;
  //     cursor: pointer;
  //     @media (max-width: @mobile) {
  //        padding: 10px;
  //        font-size: 14px;
  //     }
  // }
}

.modal__bonus {
  .modal__bonus__title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #4c2934;
  }

  .modal__bonus__result {
    margin-bottom: 10px;

    p {
      font-size: 18px;
      color: #0069ff;

      span {
        font-weight: bold;

        font-size: 20px;
      }
    }
  }

  .modal__bonus__label {
    margin-bottom: 15px;
  }

  input {
    padding: 10px;
    outline: none;
    border: 1px solid #ccc;
  }

  .modal__bonus__btn {
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    justify-content: center;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);

    p {
      color: white;
      font-weight: bold;
    }

    i {
      color: white;
    }
  }
}




.banners {
  overflow-x: scroll;

  i {
    cursor: pointer;
  }

  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
}

.green__notif_position {
  bottom: 200px;
}

p {
  margin-bottom: 0 !important;
}

.green__mb__xs {
  margin-bottom: 10px;
}

.green__mb__s {
  margin-bottom: 20px !important;
}

.green__ml__l {
  margin-left: 20px;
}

.green__mr__xs {
  margin-right: 10px;
}

.green__100 {
  width: 100%;
}

.green__row {
  display: flex;
  flex-direction: row;
}

.green__ac {
  align-items: center;
}

.green__jb {
  justify-content: space-between;
}

.green__column {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: @mobile) {
    width: 100%;
  }
}

.green__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.green__pointer {
  cursor: pointer;
}

.green__btn__color {
  color: #0069ff;
}

.green__btn__color:hover {
  opacity: 0.6;
}

.green__admin {
  min-height: 100vh;

  align-items: center;
  justify-content: center;

  .green__see {
    font-size: 18px;
    font-weight: bold;

    i {
      color: black !important;
    }
    @media (max-width: 900px) {
      font-size: 12px;
      white-space: nowrap;
    }
  }

  .green__see--active {
    color: #0069ff;
  }

  .green__images__title {
    margin-top: 40px;
    color: #0069ff;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .green__product__images__main::-webkit-scrollbar {
    height: 5px;
  }

  .green__product__images__main::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #ccc;
  }

  .green__product__images__main::-webkit-scrollbar-thumb {
    background-color: #0069ff;
    border-radius: 2px;
    height: 24px;
    width: 50px;
  }

  .green__product__images__main {
    overflow-x: auto;
    width: 50%;
  }

  .green__product__images {
    margin-bottom: 5px;
    margin-top: 5px;

    img {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      object-fit: cover;
      margin-right: 30px;
    }
  }

  .green__logout {
    align-self: flex-end;
    padding: 10px;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);
    color: white;
    margin-bottom: 20px;
    width: 140px;
    text-align: center;
  }

  .green__logout:hover {
    background: #5c8a0d;
  }

  .green__left {
    width: 20%;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 2px;

    margin-right: 20px;
    min-height: 100px;
    border-radius: 10px;

    @media (max-width: @mobile) {
      width: 100%;
      margin-left: 0;
      margin-bottom: 20px;
    }

    p {
      font-weight: bold;
      cursor: pointer;
    }

    i {
      color: white;
    }
  }

  .green__right {
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 10px;


    i {
      color: white;
    }

    .green__parents {
      p {
        font-size: 20px;
      }

      i {
        background: #0069ff;
        padding: 10px;
        font-size: 22px;
        border-radius: 50%;
        margin-right: 10px;
      }

      i:hover {
        opacity: 0.8;
      }
    }

    .green__choose {
      margin-bottom: 20px;
      .green__category__choose {
        cursor: pointer;
        padding: 20px;
        background: gray;
        margin-right: 10px;
        color: white;
        @media (max-width: @mobile) {
          font-size: 14px;
        }
        border-radius: 20px;
      }

      .green__category__active {
        background: #0069ff;
      }
    }

    .green__input {
      width: 300px;
      @media (max-width: @mobile) {
        width: 100%;
      }

      .green__input__write {
        border: 1px solid black;
        padding: 20px;
        border-radius: 2px;
        outline: none;
      }
    }

    button {
      width: 300px;
      outline: none;
      border: none;
      padding: 20px;
      background: #0069ff;
      color: white;
      @media (max-width: @mobile) {
        width: 100%;
      }
    }

    .green__edit {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      padding: 20px;

      a {
        color: #0069ff !important;
      }

      .green__user__orders {
        margin-top: 30px;
        margin-left: 10px;

        .green__user__title {
          font-weight: bold;
          font-size: 18px;
        }
      }

      @media (max-width: @mobile) {
        margin-left: 0;
      }

      .green__last__action {
        p {
          font-size: 12px;
        }
      }

      .green__data {
        margin-bottom: 10px;
        color: #0069ff;
        font-size: 18px;
      }

      .green__save__btn {
        color: #0069ff;
      }

      button {
        width: 300px;
        outline: none;
        border: none;
        background-color: #0069ff;
        color: white;
        padding: 20px;
        @media (max-width: @mobile) {
          width: 100%;
        }
      }
    }
  }
}

.green__message {
  button {
    outline: none;
    border: none;
    background-color: #0069ff;
    color: white;
    padding: 20px;
  }
}

.green__admin__inner {
  @media (max-width: @mobile) {
    flex-direction: column;
  }
}


.green__size {
  margin-top: 15px;
  margin-bottom: 15px;

  p {
    margin-bottom: 10px;
  }

  i {
    color: black !important;
  }
}

.green__submit {
  background: #0069ff;
  padding: 10px;
  color: white;
  width: 200px;

}

.green__column {
  p {
    font-weight: bold;
  }
}

.green__active {
  background: #0069ff;
  color: white;
  padding: 5px;

  i {
    color: white !important;
  }
}


.green__size--config {
  border: 1px solid black !important;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
}

.green__size {
  border: 1px solid black;
  padding: 10px;
  margin-bottom: 15px;
}
</style>
